import $ from 'jquery';
import refreshCart from './refreshCart';
import handleError from './handleError';
import cartCookies from './cartCookies';

export default function($form) {
  $.ajax({
    url: '/cart/add.js',
    dataType: 'json',
    type: 'post',
    data: $form.serialize(),
    success: () => {
      refreshCart();
    },
    error: (XHR) => {
      handleError(XHR);
    },
  });

  cartCookies($form);
}